import { MAIN_SITE_URL } from "@/utils/constants";

export default function WhatIsSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Czym jest Kakobuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Kakobuy Spreadsheet to uporządkowana baza produktów, która pozwala szybko znaleźć to, czego szukasz — bez marnowania czasu na przeszukiwanie setek ofert.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {[
            {
              title: "Oszczędność Czasu",
              desc: "Zamiast spędzać godziny na ręcznym wyszukiwaniu, przeglądasz gotowe, posegregowane listy produktów z najlepszymi ofertami. Wszystko w jednym miejscu.",
              icon: "ri-time-line",
            },
            {
              title: "Organizacja Produktów",
              desc: "Produkty są uporządkowane według kategorii — od butów, przez odzież, aż po akcesoria. Każdy produkt zawiera link do oryginalnej oferty i przydatne informacje.",
              icon: "ri-stack-line",
            },
            {
              title: "Dla Początkujących",
              desc: "Arkusz został zaprojektowany tak, aby nawet osoby, które nigdy nie korzystały z Kakobuy, mogły szybko rozpocząć zakupy i znaleźć interesujące produkty.",
              icon: "ri-user-smile-line",
            },
            {
              title: "Aktualne Informacje",
              desc: "Listy produktów są regularnie aktualizowane, dzięki czemu zawsze masz dostęp do najnowszych ofert i nie trafiasz na niedostępne już produkty.",
              icon: "ri-refresh-line",
            },
          ].map((item) => (
            <div
              key={item.title}
              className="flex gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${item.icon} text-primary-500 text-lg`}></i>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-100">
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-700 whitespace-nowrap">
                    Metoda wyszukiwania
                  </th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-700 whitespace-nowrap">
                    Czas
                  </th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-700 whitespace-nowrap">
                    Ryzyko błędu
                  </th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-700 whitespace-nowrap">
                    Efektywność
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t border-background-200/70">
                  <td className="px-4 py-3 text-foreground-700 whitespace-nowrap">Samodzielne szukanie</td>
                  <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">Długi</td>
                  <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">Wysokie</td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span className="text-secondary-500 font-medium">Niska</span>
                  </td>
                </tr>
                <tr className="border-t border-background-200/70 bg-primary-50/50">
                  <td className="px-4 py-3 text-foreground-900 font-medium whitespace-nowrap">
                    Kakobuy Spreadsheet
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span className="text-primary-500 font-medium">Krótki</span>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span className="text-primary-500 font-medium">Niskie</span>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span className="text-primary-500 font-semibold">Wysoka</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            Otwórz Kakobuy Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}